import React from 'react'
import { Gauge } from '@mui/x-charts'
import { Card, Flex } from 'antd'
import { t } from 'i18next'
import Title from 'antd/es/typography/Title'

export default function SlotEventsChart ({ slots }) {
  const slotsWithEvent = slots.filter((s) => s.events.length > 0)

  return (
    <Card>
      <Flex vertical>
        <Title level={5} style={{ textAlign: 'center' }}>
          {t('Admin.Statistic.SlotEventsChart.title')}
        </Title>
        <Gauge width={100} height={100}
          value={slotsWithEvent.length} valueMin={0} valueMax={slots.length}
          text={({ value, valueMax }) => `${value} / ${valueMax}`}
        />
      </Flex>
    </Card>
  )
}
